/**
 * Game constants and configuration.
 */

/** NES-inspired color palette */
export const PALETTE = {
  // Background
  BG_DARK: '#1a1a2e',
  BG_MEDIUM: '#16213e',
  BG_LIGHT: '#0f3460',

  // Gold / UI accent
  GOLD: '#c9a654',
  GOLD_LIGHT: '#ffe066',
  GOLD_DARK: '#a07830',

  // Red accent
  RED: '#a83232',
  RED_LIGHT: '#e05050',

  // Grass
  GRASS_DARK: '#2d5a1e',
  GRASS_MED: '#3a7a28',
  GRASS_LIGHT: '#4a9a35',

  // UI
  TEXT_WHITE: '#ffffff',
  TEXT_GREY: '#8b8b9e',
  TEXT_DARK: '#4a4a5e',

  // Blue
  BLUE: '#4a6fa5',
  BLUE_LIGHT: '#6b9fd5',
} as const;

/** Payment method labels */
export const PAYMENT_METHOD_LABELS = {
  coins: '🪙 Coins',
  cabbage: '🥬 Cabbage',
  stars: '⭐ Stars',
  tokens: '🔹 Tokens',
  green_papers: '🥬 Cabbage',
  star_papers: '⭐ Stars',
} as const;

/** Animation FPS presets */
export const ANIMATION_FPS = {
  HERO_IDLE: 3,
  FRIEND_IDLE: 2.5,
  COIN_SPIN: 4,
} as const;

/** Polling interval for payment status (ms) */
export const POLL_INTERVAL_MS = 20_000;

/** Monthly battle cycle date constants */
export const BATTLE_CYCLE = {
  FIRST_BATTLE_DAY: 22,
  FINAL_BATTLE_DAY: 7,
  SACRIFICE_START_DAY: 8,
  SACRIFICE_END_DAY: 12,
} as const;

// ── i18n ──
export { TRANSLATIONS, t } from './i18n';
export type { TranslationKey } from './i18n';
